import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import Slider from "react-slick";

export default function CardDetail() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loaderTimeout = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    const navigateTimeout = setTimeout(() => {
      navigate(`/thank-you`);
    }, 2000);

    return () => {
      clearTimeout(loaderTimeout);
     clearTimeout(navigateTimeout);
    };
  }, [navigate]);

  return (
    <>


      <section className="commn-bg-set">
        <div className="card-center-set">
        {isLoading ? (
          <div className="loading-overlay">
            <Spinner
              animation="border"
              role="status"
              style={{ color: "#e58d2e", width: "3rem", height: "3rem" }}
            >
              <span className="visually-hidden"></span>
            </Spinner>
          </div>
        ) :
            <div className="payment-card-detail">
              <img
                className="side-logo-set"
                src={require("../Assets/images/logo-main.png")}
              />
              <div className="check-img-center">
                <img src={require("../Assets/images/checkicon.png")} />
              </div>
          </div>
        }
        </div>
      </section>

    </>
  );
}